export enum ErrorCodesEnum {
  E_UNKNOWN = 'E_UNKNOWN',
  E_PAYMENT_CANCELLED = 'E_PAYMENT_CANCELLED',
}
